import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetUsersByPeopleIdsGraphQlRequest, GetUsersByPeopleIdsGraphResponse } from './types';

export const getUserByPeopleIdsQuery = gql`
  query PayrollGetUsersByPeopleIds($input: PayrollGetUsersByPeopleIdsInput!) {
    payrollGetUsersByPeopleIds(input: $input) {
      data {
        employees {
          name
          email
          peopleId
          organizationId
          employeeId
          idPrefix
        }
        total
      }
      code
      success
      message
    }
  }
`;

export const getUserByPeopleIds = (queryVariables: GetUsersByPeopleIdsGraphQlRequest) => {
  return graphQLApi<GetUsersByPeopleIdsGraphResponse, GetUsersByPeopleIdsGraphQlRequest>({
    query: getUserByPeopleIdsQuery,
    queryVariables,
  });
};

export default getUserByPeopleIds;
